import type { SelectedOptionsProps } from '../../generic/Filter';
import { CheckboxFilterGroup, FilterPanel } from '../../generic/Filter';
import type { QualityIssueType } from '../../../../shared/issuesV2';

const FILTER_OPTIONS: Array<{ key: QualityIssueType, label: string }> = [
  { key: 'outdated_dependency', label: 'Outdated version' },
  { key: 'blacklisted_dependency', label: 'Blocked package' },
  { key: 'risk_abandonware', label: 'Abandonware' },
  { key: 'risk_empty-package', label: 'Empty package' },
  { key: 'risk_native-code', label: 'Native code' },
];

const QualityIssueFilter = ({ selectedOptions, onSelect }: SelectedOptionsProps) =>
  <FilterPanel>
    <CheckboxFilterGroup
      title="Issue type"
      options={FILTER_OPTIONS}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      testId="issues-quality-filters"
    />
  </FilterPanel>;

export default QualityIssueFilter;
